export enum ResponseErrors {
  googleMFA = 'Please, enter two-factor authentication (2FA) code',
  emailMFA = 'Please, enter email two-factor authentication (2FA) one-time password',
  deletedWallet = "Provided wallet doesn't exist",
}

export enum AliasError {
  alreadyTaken = 'This alias is already taken.',
}
